// English for the Teaching strings that are not in the ARB files yet.
//
// The ARB files (lib/l10n/app_*.arb) are the single source of every UI
// string, and web/src/i18n/locales/*.json is generated from them. The
// Teaching redesign's web lane added strings while the ARB was owned by the
// Flutter lane, so the English text lives here until the keys are added to
// app_en.arb / app_de.arb:
//   * merged UNDER the generated English bundle (i18n/index.ts), so the
//     moment a key exists in the ARB, the ARB text wins — no code change;
//   * every other locale falls back to English for a key it lacks, as for
//     any untranslated ARB key.
// Once a key is in the ARB, delete it here. teachingFallbacks.test.ts fails
// if a Teaching screen uses a key that is in neither place, or passes the
// wrong placeholders.
//
// Messages are ICU, like the ARB: `{name}`, `{count, plural, =1{…} other{…}}`.

// Every teaching key now lives in lib/l10n/app_en.arb / app_de.arb. Keep
// this registry for keys a screen needs before the ARB has them; the test
// fails on any key found in neither place.
export const TEACHING_FALLBACKS_EN: Record<string, string> = {};
